import React from 'react';
import moment from 'moment';
import { Form } from 'components';
import TEXT_CAPTIONS from './constants';
import StaffPresentSelect from './StaffPresentSelect';
import useLaunchDarkly from 'hooks/useLaunchDarkly';

const MealActivityForm = ({ activity, constants, useDate = true, forceStaff }) => {
  const flags = useLaunchDarkly();
  return (
    <div className="form__body">
      {useDate && (
        <div className="form__row form__row--datetime">
          <Form.DatePicker label="Date" name="date" defaultValue={moment(activity.activity_time).toDate()} required />

          <Form.TimeInput label="Time" name="time" defaultValue={Helpers.formatTime(activity.activity_time)} required />
        </div>
      )}

      <div className="form__row form__row--justified">
        <Form.Select name="type" defaultValue={activity.data.type} title="Type" label="Type" data-cy="type" required>
          {constants.meals.type.map(type => (
            <Form.Select.Item label={type} value={type} key={type} />
          ))}
        </Form.Select>

        <Form.Select
          name="quantity"
          defaultValue={activity.data.quantity}
          title="Quantity"
          label="Quantity"
          data-cy="quantity"
          required
        >
          {constants.meals.quantity.map(quantity => (
            <Form.Select.Item label={quantity} value={quantity} key={quantity} />
          ))}
        </Form.Select>
      </div>

      <StaffPresentSelect activity={activity} />

      <div className="form__row">
        <Form.Textarea
          name="description"
          defaultValue={activity.data.desc}
          placeholder="Description"
          label="Description"
        />
      </div>

      <div className="form__row">
        {forceStaff ? (
          TEXT_CAPTIONS.staffOnlyForce
        ) : (
          <Form.Checkbox
            type="circle"
            name="staffOnly"
            label={TEXT_CAPTIONS.staffOnly}
            defaultValue={flags['activities-feed'] ? activity.approval_status === 'pending' : activity.is_staff_only}
          />
        )}
      </div>
    </div>
  );
};

export default MealActivityForm;
